export default __webpack_public_path__ + "static/media/VERSA.0360743d.svg";